import { SVGProps } from 'react';

export const IconBookmarkEmpty = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg viewBox='-3 -1 20 20' {...props}>
      <g stroke='currentColor' strokeWidth='1.2' fillRule='evenodd' fill={props.fill}>
        <path d='M6.345 1c1.79 0 3.627.08 4.956.227.397.044.746.093 1.026.149l.095.019.005.048c.019.239.023.541.036.904l.008.225c.061 1.453.152 3.629.22 5.89l.023.748c.067 2.419.104 4.857.045 6.54-.014.407-.033.766-.06 1.065l-.008.082-.15-.044c-1.315-.445-2.375-1.813-3.21-2.831l-.13-.158c-1.012-1.217-1.847-1.815-2.34-1.815-.492 0-1.353.615-2.398 1.827-.887 1.03-2.023 2.513-3.38 2.978l-.026.006-.006-.108a54.006 54.006 0 0 1-.05-2.29v-1.004c.007-3.429.125-7.98.193-10.603.016-.623.03-1.138.038-1.507l-.001-.009.025-.006c.155-.035.336-.066.538-.095l.208-.029C3.125 1.065 4.715 1 6.345 1z' />
      </g>
    </svg>
  );
};
